var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.form.name !== "SpanLayout"
        ? _c(
            "el-form",
            { attrs: { "label-width": "90px", "label-position": "top" } },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  attrs: { label: "表单id" },
                },
                [
                  _c("el-input", {
                    attrs: { size: "small", readonly: true },
                    model: {
                      value: _vm.form.id,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "id", $$v)
                      },
                      expression: "form.id",
                    },
                  }),
                ],
                1
              ),
              _vm.form.name !== "Description" && _vm.form.name !== "JoinDate"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "标题" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          clearable: "",
                          maxlength: "50",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "title", $$v)
                          },
                          expression: "form.title",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(_vm.form.name, {
                tag: "component",
                attrs: { formName: _vm.form.name },
                model: {
                  value: _vm.form.props,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "props", $$v)
                  },
                  expression: "form.props",
                },
              }),
              _c(
                "el-form-item",
                {
                  staticClass: "form-other",
                  attrs: { label: _vm.form.name == "JoinDate" ? "" : "其他" },
                },
                [
                  _vm.form.name === "SelectInput" ||
                  _vm.form.name === "MultipleSelect"
                    ? _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.props.expanding,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.props, "expanding", $$v)
                            },
                            expression: "form.props.expanding",
                          },
                        },
                        [
                          _c("span", { staticClass: "name-text" }, [
                            _vm._v("选择平铺"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.form.name !== "Description" &&
                  _vm.form.name !== "JoinDate"
                    ? _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.props.required,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.props, "required", $$v)
                            },
                            expression: "form.props.required",
                          },
                        },
                        [
                          _c("span", { staticClass: "name-text" }, [
                            _vm._v("必填"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.form.name === "Description"
                    ? _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.props.showDetail,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.props, "showDetail", $$v)
                            },
                            expression: "form.props.showDetail",
                          },
                        },
                        [
                          _c("span", { staticClass: "name-text" }, [
                            _vm._v("不在审批页显示"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.form.props.enablePrint,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.props, "enablePrint", $$v)
                        },
                        expression: "form.props.enablePrint",
                      },
                    },
                    [
                      _c("span", { staticClass: "name-text" }, [
                        _vm._v("参与打印"),
                      ]),
                      _c("span", { staticClass: "min-text" }, [
                        _vm._v("如不勾选，打印时不显示该项"),
                      ]),
                    ]
                  ),
                  _vm.form.name === "AmountInput"
                    ? _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.props.showChinese,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.props, "showChinese", $$v)
                            },
                            expression: "form.props.showChinese",
                          },
                        },
                        [
                          _c("span", { staticClass: "name-text" }, [
                            _vm._v("显示大写"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _c("el-empty", { attrs: { description: "当前组件不支持配置" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }